import { PipeTransform } from '@angular/core';
var TruncatePipe = /** @class */ (function () {
    function TruncatePipe() {
    }
    TruncatePipe.prototype.transform = function (value, limit, trail) {
        if (trail === void 0) { trail = '...'; }
        var l = limit ? parseInt(limit, 10) : 10;
        var t = trail ? trail : '...';
        return value && value.length > l ? value.substring(0, l) + t : value;
    };
    return TruncatePipe;
}());
export { TruncatePipe };
